export function app() {
  return {
    isMenuOpen: false,
    overflowHidden: false,
  };
}
